import React from "react";
import TopNavbar from "../../shares/TopNavbar";
import { GlobeAltIcon, ShieldCheckIcon } from "@heroicons/react/24/outline";

const FORA_LOGIN_URL = "https://gofora.net/Account/Login/1";

export default function Signin() {
  return (
    <div className="min-h-screen bg-slate-100">
      <TopNavbar />
      <main className="mx-auto max-w-5xl px-4 py-10 sm:px-6 sm:py-16">
        <section className="rounded-3xl border border-slate-200 bg-white p-6 shadow-sm sm:p-10">
          <div className="inline-flex items-center gap-2 rounded-full border border-slate-300 bg-slate-100 px-4 py-2 text-sm font-semibold text-slate-700">
            <ShieldCheckIcon className="h-4 w-4" />
            GoFora Function Login Only
          </div>

          <h1 className="mt-6 text-3xl font-bold tracking-tight text-slate-950 sm:text-5xl">
            Access Fora Connector
          </h1>

          <p className="mt-5 max-w-3xl text-lg leading-8 text-slate-700">
            We could not find your company access context. Please sign in on
            gofora.net, then open Fora Connector from the side menu.
          </p>

          <div className="mt-8 rounded-3xl border border-slate-200 bg-slate-50 p-6 sm:p-8">
            <h2 className="text-xl font-bold text-slate-950">
              How to access Fora Connector
            </h2>
            <ol className="mt-4 list-decimal space-y-2 pl-6 text-lg text-slate-700">
              <li>Sign in to your staff account at gofora.net.</li>
              <li>In the side menu, select Fora Connector.</li>
              <li>Fora Connector will open automatically with your function login access.</li>
            </ol>
          </div>

          <a
            href={FORA_LOGIN_URL}
            className="mt-8 inline-flex w-full items-center justify-center gap-3 rounded-full bg-slate-950 px-6 py-4 text-xl font-semibold text-white transition hover:bg-slate-900"
          >
            <GlobeAltIcon className="h-6 w-6" />
            Open gofora.net
            <span aria-hidden>?</span>
          </a>
        </section>
      </main>
    </div>
  );
}
